/* import __COLOCATED_TEMPLATE__ from './torque.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();